<h1 class="page-header">Dashboard por Periodos</h1>

<panel noButton="true" class="mb-5">
  <div class="row mb-4">
    <div class="col-md-3">
      <label class="form-label">Período Solicitudes</label>
      <input type="month" class="form-control" [(ngModel)]="period" (change)="load()" />
    </div>
    <div class="col-md-3">
      <label class="form-label">Entidad</label>
      <ng-select
        [items]="entities"
        bindLabel="name"
        bindValue="_id"
        [(ngModel)]="selectedEntityId"
        placeholder="Todas las entidades"
        clearable="true"
        (change)="load(); loadInsured()">
      </ng-select>
    </div>
    <div class="col-md-2 d-flex align-items-end">
      <button class="btn btn-primary w-100" (click)="load()">
        <i class="fa fa-search"></i> Cargar
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <p class="mt-2">Cargando solicitudes...</p>
    </div>
  }

  @if (data?.requests && !loading) {
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <div echarts [options]="chartTypeOptions" style="height: 320px; width: 100%"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <div echarts [options]="chartStateOptions" style="height: 320px; width: 100%"></div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="row mb-3">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <span class="fs-5 fw-bolder">Asegurados</span>
      <button class="btn btn-success btn-sm" (click)="exportExcel('coverage')">
        <i class="fa fa-file-excel"></i> Exportar
      </button>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-md-3">
      <label class="form-label">Mes</label>
      <input type="month" class="form-control" [(ngModel)]="insuredMonth" (change)="loadInsured()" />
    </div>
    <div class="col-md-3">
      <label class="form-label">Cobertura</label>
      <ng-select
        [items]="coverages"
        bindLabel="name"
        bindValue="_id"
        [(ngModel)]="selectedCoverageId"
        placeholder="Todas las coberturas"
        clearable="true"
        (change)="loadInsured()">
      </ng-select>
    </div>
    <div class="col-md-2 d-flex align-items-end">
      <button class="btn btn-primary w-100" (click)="loadInsured()">
        <i class="fa fa-search"></i> Cargar
      </button>
    </div>
  </div>

  @if (loadingInsured) {
    <div class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <p class="mt-2">Cargando asegurados...</p>
    </div>
  }

  @if (data?.insured && !loadingInsured) {
    <div class="row mb-4">
      <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
        <div class="widget widget-stats bg-indigo-600 h-100" role="button" (click)="openDetail('coverage')" style="cursor:pointer">
          <div class="stats-icon stats-icon-md"><i class="fa fa-users fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title text-white">Total Asegurados</div>
            <div class="stats-number text-white">{{ data.insured.summary.totalInsured }}</div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
        <div class="widget widget-stats bg-blue-600 h-100" role="button" (click)="openDetail('campus')" style="cursor:pointer">
          <div class="stats-icon stats-icon-md"><i class="fa fa-user fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title text-white">Titulares</div>
            <div class="stats-number text-white">{{ data.insured.summary.holders }}</div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
        <div class="widget widget-stats bg-teal-600 h-100">
          <div class="stats-icon stats-icon-md"><i class="fa fa-user-friends fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title text-white">Cargas</div>
            <div class="stats-number text-white">{{ data.insured.summary.dependents }}</div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
        <div class="widget widget-stats bg-orange-600 h-100" role="button" (click)="openDetail('turning65')" style="cursor:pointer">
          <div class="stats-icon stats-icon-md"><i class="fa fa-hourglass-end fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title text-white">Jubilados</div>
            <div class="stats-number text-white">{{ data.insured.summary.turning65 }}</div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
        <div class="widget widget-stats bg-purple-600 h-100" role="button" (click)="openDetail('turning65During')" style="cursor:pointer">
          <div class="stats-icon stats-icon-md"><i class="fa fa-clock fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title text-white">Próximos Jubilados</div>
            <div class="stats-number text-white">{{ data.insured.summary.turning65During }}</div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
        <div class="widget widget-stats bg-pink-600 h-100" role="button" (click)="openDetail('cargos')" style="cursor:pointer">
          <div class="stats-icon stats-icon-md"><i class="fa fa-briefcase fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title text-white">Cargos</div>
            <div class="stats-number text-white">{{ data.insured.summary.cargos }}</div>
          </div>
        </div>
      </div>
    </div>
  }
</panel>
<ng-template><dashboard-detail-modal /></ng-template>
